// src/libraries/SelectionLibrary.js

class SelectionLibrary {
  constructor() {
    this.selectedObjects = [];  // 🔥 now array
    this.listeners = [];
    
  }

  setSelection(objArray) {
    this.selectedObjects = Array.isArray(objArray) ? objArray : [objArray]; // FORCE array
    this.notifyListeners();
  }
  

  getSelection() {
    return this.selectedObjects;
  }

  clearSelection() {
    this.selectedObjects = [];  // 🔥 clear array
    this.notifyListeners();
  }

  onChange(callback) {
    this.listeners.push(callback);
  }

  notifyListeners() {
    this.listeners.forEach((cb) => cb(this.selectedObjects));
  }
}

const selectionLibrary = new SelectionLibrary();
export default selectionLibrary;
